/**
 * Data Access Object for the employee endpoint.
 *
 * @module app.dao
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(rise, app) {
    "use strict";

    var Rpc = rise.Rpc;
    var log = rise.logging.getLogger("dao.employee");

    /*** Export Dao ***/
    app.dao.customerUserDao = new CustomerUserDao();

    /**
     * @constructor
     */
    function CustomerUserDao() {
        // call parent constructor
        rise.Dao.call(this, app.model.CustomerUser, new Rpc('/rpc/customer-user'));
    }

    // extend the parent Dao prototype
    $.extend(CustomerUserDao.prototype, Object.create(rise.Dao.prototype));

    CustomerUserDao.prototype.listAll = function(params) {
        log.info('List all Customer Users');
        var deferred = new $.Deferred();
        var self = this;

        self.rpc.invoke('list_all', params)
            .done(function(data) {
                if (data.length === 0) {
                    log.info('No Customer User data sets found');
                    deferred.resolve([]);
                } else {
                    log.info('Received %s Customer User(s)', data.length);
                    deferred.resolve(data.map(function(d) {
                        return new app.dto.UserListDto(d);
                    }));
                }
            })
            .fail(function(error) {
                log.error('Fetching all Customer Users failed. %s', error.message);
                deferred.reject(error);
            });

        return deferred.promise();
    };


})(window.rise, window.app);
